/**
@license
Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
import { store } from '../store.js';
import { fbConfig, fbConfigStaging } from '../firebaseConfig';
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager, updateDoc, getDoc, doc, onSnapshot, getDocs, collection } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_OFFLINE = 'UPDATE_OFFLINE';
export const UPDATE_DRAWER_STATE = 'UPDATE_DRAWER_STATE';
export const OPEN_SNACKBAR = 'OPEN_SNACKBAR';
export const CLOSE_SNACKBAR = 'CLOSE_SNACKBAR';
export const FIREBASE_INITIALIZE = 'FIREBASE_INITIALIZE';
export const FIREBASE_AUTH_INITIALIZE = 'FIREBASE_AUTH_INITIALIZE';
export const FIREBASE_AUTHORIZE = 'FIREBASE_AUTHORIZE';
export const FIREBASE_SIGNOUT = 'FIREBASE_SIGNOUT';
export const FIREBASE_FIRESTORE = 'FIREBASE_FIRESTORE';
export const COMPANY_LOADED = 'COMPANY_LOADED';
export const VENDOR_LOADED = 'VENDOR_LOADED';
export const PERSON_LOADED = 'PERSON_LOADED';
export const LOAD_ORGANIZATIONS = 'LOAD_ORGANIZATIONS';
export const ORGANIZATIONS_LOADED = 'ORGANIZATIONS_LOADED';
export const LOAD_JOBS = 'LOAD_JOBS';
export const JOBS_LOADED = 'JOBS_LOADED';
export const JOB_GET = 'JOB_GET';
export const LOAD_JOBTYPES = 'LOAD_JOBTYPES';
export const JOBTYPES_LOADED = 'JOBTYPES_LOADED';
export const LOAD_BACKGROUNDSETS = 'LOAD_BACKGROUNDSETS';
export const BACKGROUNDSETS_LOADED = 'BACKGROUNDSETS_LOADED';
export const LOAD_BACKGROUNDS = 'LOAD_BACKGROUNDS';
export const BACKGROUNDS_LOADED = 'BACKGROUNDS_LOADED';
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
;
export const navigate = (path) => (dispatch) => {
    // Extract the page name from path. Remove Querystring
    const page = path === '/' ? 'home' : path.slice(1).split("#")[0].split("?")[0];
    dispatch(loadPage(page));
    window.history.pushState({}, '', path);
    // Close the drawer - in case the *path* change came from a link in the drawer.
    dispatch(updateDrawerState(false));
};
const safeLoadComponent = async (importFn) => {
    try {
        await importFn();
    }
    catch (err) {
        console.warn('[BWS] Error dynamically loading page chunk:', err);
        const errStr = String(err && (err.message || err));
        const isChunkError = errStr.includes('Loading chunk') ||
            errStr.includes('ChunkLoadError') ||
            errStr.includes('Failed to fetch') ||
            errStr.includes('dynamically imported module');
        if (isChunkError) {
            if (!navigator.onLine) {
                console.warn('[BWS] Chunk load error while offline; preserving cache and aborting reload:', errStr);
                return;
            }
            const reloadKey = 'bws_chunk_reload_ts';
            const lastReload = sessionStorage.getItem(reloadKey);
            const now = Date.now();
            if (!lastReload || now - parseInt(lastReload, 10) > 30000) {
                sessionStorage.setItem(reloadKey, String(now));
                console.warn('[BWS] Reloading page to fetch updated application bundle...');
                if ('caches' in window) {
                    try {
                        const names = await caches.keys();
                        await Promise.all(names.map((n) => caches.delete(n)));
                    }
                    catch (_) { }
                }
                window.location.reload();
                return;
            }
        }
        try {
            await import('../components/my-view404.js');
        }
        catch (_) { }
    }
};
const loadPage = (page) => (dispatch) => {
    switch (page.split("#")[0].split("/")[0]) {
        case 'login':
            safeLoadComponent(() => import('../components/templates/my-login.js')).then(() => {
                dispatch(updatePage(page));
            });
            break;
        case 'home':
            safeLoadComponent(() => import('../components/my-home.js'));
            break;
        case 'capture':
            safeLoadComponent(() => import('../components/my-capture.js'));
            break;
        case 'jobs':
            safeLoadComponent(() => import('../components/my-jobs.js'));
            break;
        case 'organizations':
            safeLoadComponent(() => import('../components/my-organizations.js'));
            break;
        case 'company':
            safeLoadComponent(() => import('../components/my-company.js'));
            break;
        case 'production':
            safeLoadComponent(() => import('../components/my-production.js'));
            break;
        case 'orders':
            safeLoadComponent(() => import('../components/my-orders.js'));
            break;
        case 'customerservice':
            safeLoadComponent(() => import('../components/my-customerservice.js'));
            break;
        case 'job':
            safeLoadComponent(() => import('../components/my-job.js'));
            break;
        case 'accounting':
            safeLoadComponent(() => import('../components/my-accounting.js'));
            break;
        case 'layouts':
            safeLoadComponent(() => import('../components/my-layouts.js'));
            break;
        case 'lab':
            safeLoadComponent(() => import('../components/my-lab.js'));
            break;
        case 'sales':
            safeLoadComponent(() => import('../components/my-sales.js'));
            break;
        case 'photography':
            safeLoadComponent(() => import('../components/my-photography.js'));
            break;
        case 'vendor':
            safeLoadComponent(() => import('../components/vendor/vendor-vendor.js'));
            break;
        case 'vendorjobs':
            safeLoadComponent(() => import('../components/vendor/vendor-jobs.js'));
            break;
        case 'oauth':
            console.log(page);
            break;
        default:
            page = 'view404';
            safeLoadComponent(() => import('../components/my-view404.js'));
    }
    if (page != 'login')
        dispatch(updatePage(page));
};
const updatePage = (page) => {
    return {
        type: UPDATE_PAGE,
        page
    };
};
let snackbarTimer;
export const showSnackbar = () => (dispatch) => {
    dispatch({
        type: OPEN_SNACKBAR
    });
    window.clearTimeout(snackbarTimer);
    snackbarTimer = window.setTimeout(() => dispatch({ type: CLOSE_SNACKBAR }), 3000);
};
export const updateOffline = (offline) => (dispatch, getState) => {
    // Show the snackbar only if offline status changes.
    if (offline !== getState().app.offline) {
        dispatch(showSnackbar());
    }
    dispatch({
        type: UPDATE_OFFLINE,
        offline
    });
};
export const updateDrawerState = (opened) => {
    return {
        type: UPDATE_DRAWER_STATE,
        opened
    };
};
export const firebaseInitialize = () => (dispatch) => {
    let fb = initializeApp(["staging.bluewatersuite.net", "localhost", "test.bluewatersuite.net", "sawyer-staging-cart.web.app"].indexOf(location.hostname) > -1 && location.hash !== "#live" ? fbConfigStaging : fbConfig);
    let appCheckProvider = "6LdEkSEqAAAAADS7u0lRH57Jt-tjHPkzg4bOEZ08";
    if (location.hostname === "localhost") {
        // @ts-ignore
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
        appCheckProvider = "6LdCsngtAAAAANQHLEqc8d068GpWnj3yLBF_xSDL";
    }
    initializeAppCheck(fb, {
        provider: new ReCaptchaV3Provider(appCheckProvider),
        isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
    });
    let firestore;
    try {
        firestore = initializeFirestore(fb, {
            localCache: persistentLocalCache({
                tabManager: persistentMultipleTabManager()
            })
        });
    }
    catch (_) {
        firestore = getFirestore(fb);
    }
    var auth = getAuth(fb);
    const storage = getStorage(fb);
    const functions = getFunctions(fb);
    window.firebase = fb;
    window.firestore = firestore;
    window.functions = functions;
    window.auth_instance = auth;
    window.storage = storage;
    dispatch(firebaseAuthInitialize(fb, firestore));
    dispatch({
        type: FIREBASE_INITIALIZE,
        firebase: fb,
        firestore: firestore
    });
};
export const firebaseAuthInitialize = (fb) => (dispatch) => {
    if (fb) {
        var auth = getAuth(fb);
        if (["test.bluewatersuite.net", "localhost"].includes(location.hostname) && location.hash !== "#live") {
            // connectAuthEmulator(auth, 'http://localhost:9099');
        }
        // No setPersistence: getAuth already persists to IndexedDB; forcing localStorage bounced other open tabs to /login
        onAuthStateChanged(auth, (u) => {
            dispatch(firebaseAuthorize(u));
        });
    }
    dispatch({
        type: FIREBASE_AUTH_INITIALIZE
    });
};
export function createMockDocumentSnapshot(firestore, path, id, data) {
    const docRef = doc(firestore, path);
    return {
        id: id || docRef.id,
        ref: docRef,
        exists: () => true,
        data: () => ({ ...(data || {}) }),
        get: (fieldPath) => {
            if (!fieldPath || !data)
                return undefined;
            if (fieldPath in data)
                return data[fieldPath];
            const parts = fieldPath.split('.');
            let curr = data;
            for (const p of parts) {
                if (!curr || typeof curr !== 'object')
                    return undefined;
                curr = curr[p];
            }
            return curr;
        },
        metadata: { hasPendingWrites: false, fromCache: true }
    };
}
export function saveOfflineAuthData(userDoc, personDoc, companyDoc, settingsMap) {
    try {
        const authData = {
            uid: userDoc.id,
            userProfile: {
                id: userDoc.id,
                path: userDoc.ref.path,
                data: userDoc.data()
            },
            savedAt: new Date().toISOString()
        };
        if (personDoc && personDoc.exists()) {
            authData.person = {
                id: personDoc.id,
                path: personDoc.ref.path,
                data: personDoc.data()
            };
        }
        if (companyDoc && companyDoc.exists()) {
            authData.company = {
                id: companyDoc.id,
                path: companyDoc.ref.path,
                data: companyDoc.data()
            };
        }
        if (settingsMap) {
            authData.settings = {};
            settingsMap.forEach((snap, key) => {
                authData.settings[key] = {
                    id: snap.id,
                    path: snap.ref.path,
                    data: snap.data()
                };
            });
        }
        localStorage.setItem('bws_offline_auth', JSON.stringify(authData));
        console.log('[BWS] Saved offline auth context to localStorage.');
    }
    catch (e) {
        console.warn('[BWS] Could not save offline auth data:', e);
    }
}
export function loadOfflineAuthData(firestoreInstance, uid) {
    try {
        const raw = localStorage.getItem('bws_offline_auth');
        if (!raw)
            return null;
        const data = JSON.parse(raw);
        if (uid && data.uid && data.uid !== uid)
            return null;
        const res = {};
        if (data.userProfile) {
            res.userDoc = createMockDocumentSnapshot(firestoreInstance, data.userProfile.path, data.userProfile.id, data.userProfile.data);
        }
        if (data.person) {
            res.personDoc = createMockDocumentSnapshot(firestoreInstance, data.person.path, data.person.id, data.person.data);
        }
        if (data.company) {
            res.companyDoc = createMockDocumentSnapshot(firestoreInstance, data.company.path, data.company.id, data.company.data);
        }
        if (data.settings) {
            const sMap = new Map();
            for (const [k, v] of Object.entries(data.settings)) {
                sMap.set(k, createMockDocumentSnapshot(firestoreInstance, v.path, v.id, v.data));
            }
            res.settingsMap = sMap;
        }
        return res;
    }
    catch (e) {
        console.warn('[BWS] Failed reading offline auth data:', e);
        return null;
    }
}
export const firebaseAuthorize = (user) => (dispatch) => {
    if (user) {
        if (!user.isAnonymous) {
            const isOnline = navigator.onLine;
            const handleOfflineAuthFallback = () => {
                console.log('[BWS] Attempting offline auth restoration...');
                const offlineData = loadOfflineAuthData(window.firestore, user.uid);
                if (offlineData && offlineData.userDoc) {
                    console.log('[BWS] Restored auth context from offline storage.');
                    dispatch(firebaseFirestore(offlineData.userDoc));
                    if (offlineData.personDoc) {
                        //@ts-ignore
                        window.person = offlineData.personDoc;
                        dispatch(personLoaded(offlineData.personDoc));
                    }
                    if (offlineData.companyDoc) {
                        window.company = offlineData.companyDoc;
                        window.bws_settings = offlineData.settingsMap || new Map();
                        dispatch(companyLoaded(offlineData.companyDoc));
                    }
                    return true;
                }
                return false;
            };
            if (!isOnline) {
                console.log('[BWS] Device is offline; bypassing online auth token fetch.');
                dispatch({
                    type: FIREBASE_AUTHORIZE,
                    user,
                    forcePasswordChange: false
                });
                const restored = handleOfflineAuthFallback();
                if (!restored) {
                    console.warn('[BWS] Offline and no cached auth context found.');
                }
                return;
            }
            user.getIdTokenResult(true).then((idTokenResult) => {
                const forcePasswordChange = idTokenResult.claims.forcePasswordChange === true ||
                    idTokenResult.claims.needsPasswordReset === true ||
                    idTokenResult.claims.passwordExpired === true;
                dispatch({
                    type: FIREBASE_AUTHORIZE,
                    user,
                    forcePasswordChange
                });
                if (forcePasswordChange) {
                    // Bypass database loading entirely until password is reset!
                    return;
                }
                const docRef = doc(window.firestore, "UserProfiles", user.uid);
                getDoc(docRef).then((userDoc) => {
                    if (userDoc.exists() && userDoc.get("person")) {
                        const personRef = userDoc.get("person");
                        onSnapshot(personRef, (personDoc) => {
                            if (personDoc.exists()) {
                                dispatch(personLoaded(personDoc));
                                if (window.company) {
                                    saveOfflineAuthData(userDoc, personDoc, window.company, window.bws_settings);
                                }
                            }
                        }, (err) => {
                            console.warn('[BWS] onSnapshot personRef error (likely offline):', err);
                        });
                        dispatch(firebaseFirestore(userDoc));
                    }
                    else if (!navigator.onLine) {
                        handleOfflineAuthFallback();
                        return;
                    }
                    else {
                        dispatch(firebaseSignOut());
                        return;
                    }
                    if (userDoc.exists() && userDoc.get("company")) {
                        const companyRef = userDoc.get("company");
                        getDoc(companyRef).then(async (companyDoc) => {
                            var _a;
                            if (!companyDoc.exists() || !companyDoc.get("active")) {
                                dispatch(firebaseSignOut());
                                return;
                            }
                            if (companyDoc.exists()) {
                                let settingsMap = new Map();
                                try {
                                    const settings = await getDocs(collection(companyDoc.ref, "Settings"));
                                    settings.docs.forEach((set) => {
                                        settingsMap.set(set.id, set);
                                    });
                                }
                                catch (e) {
                                    console.warn('[BWS] Could not get settings collection, checking cache:', e);
                                }
                                window.bws_settings = settingsMap;
                                dispatch(companyLoaded(companyDoc));
                                dispatch(firebaseFirestore(userDoc));
                                dispatch(loadOrganizations(companyDoc.ref));
                                // Save offline auth context to localStorage
                                saveOfflineAuthData(userDoc, window.person || null, companyDoc, settingsMap);
                                // Idle pre-warm Capture Link chunk if company has CAPTURE_LINK app
                                const apps = (_a = companyDoc.data()) === null || _a === void 0 ? void 0 : _a.apps;
                                if (Array.isArray(apps) && apps.includes('CAPTURE_LINK')) {
                                    const prewarmCapture = () => {
                                        import('../components/my-capture.js').catch(() => { });
                                    };
                                    if ('requestIdleCallback' in window) {
                                        window.requestIdleCallback(prewarmCapture);
                                    }
                                    else {
                                        setTimeout(prewarmCapture, 2000);
                                    }
                                }
                                if (!forcePasswordChange && (window.location.pathname === '/login' || window.location.pathname === '/')) {
                                    dispatch(navigate('/home'));
                                }
                            }
                        }).catch((error) => {
                            console.error("Error getting company doc", error);
                            const restored = handleOfflineAuthFallback();
                            if (!restored) {
                                dispatch(firebaseSignOut());
                            }
                        });
                    }
                    else if (!navigator.onLine) {
                        handleOfflineAuthFallback();
                    }
                    else {
                        dispatch(firebaseSignOut());
                    }
                    if (userDoc.exists() && userDoc.get("vendor")) {
                        const vendorRef = userDoc.get("vendor");
                        getDoc(vendorRef).then((vendorDoc) => {
                            if (vendorDoc.exists()) {
                                dispatch(vendorLoaded(vendorDoc));
                                if (!forcePasswordChange && (window.location.pathname === '/login' || window.location.pathname === '/')) {
                                    dispatch(navigate('/home'));
                                }
                            }
                        }).catch(() => { });
                        dispatch(firebaseFirestore(userDoc));
                    }
                    if (!userDoc || !userDoc.exists() || (!userDoc.get("company") && !userDoc.get("vendor"))) {
                        if (navigator.onLine) {
                            dispatch(navigate('/login'));
                        }
                        else {
                            handleOfflineAuthFallback();
                        }
                    }
                }).catch((err) => {
                    console.warn('[BWS] Error getting user profile doc:', err);
                    const restored = handleOfflineAuthFallback();
                    if (!restored && navigator.onLine) {
                        dispatch(navigate('/login'));
                    }
                });
            }).catch((err) => {
                console.warn("[BWS] Error getting user custom claims:", err);
                dispatch({
                    type: FIREBASE_AUTHORIZE,
                    user,
                    forcePasswordChange: false
                });
                const restored = handleOfflineAuthFallback();
                if (!restored && navigator.onLine) {
                    dispatch(navigate('/login'));
                }
            });
        }
        else {
            dispatch({
                type: FIREBASE_AUTHORIZE,
                user
            });
            dispatch(navigate('/login'));
        }
    }
    else {
        dispatch({
            type: FIREBASE_AUTHORIZE,
            user
        });
        if (navigator.onLine) {
            dispatch(navigate('/login'));
        }
    }
};
export const companyLoaded = (companyDoc) => {
    return {
        type: COMPANY_LOADED,
        companyDoc: companyDoc
    };
};
export const vendorLoaded = (vendorDoc) => {
    return {
        type: VENDOR_LOADED,
        vendorDoc
    };
};
export const personLoaded = (personDoc) => {
    if (window.location.pathname.indexOf("oauth") >= -1)
        personIntegrationReceived(window.location.pathname.split("/")[2], personDoc);
    return {
        type: PERSON_LOADED,
        personDoc
    };
};
export const personIntegrationReceived = (partnerId, personDoc) => {
    if (partnerId && personDoc) {
        partnerId = partnerId.toUpperCase();
        var integration = {};
        integration[partnerId] = {};
        const personDocRef = doc(window.firestore, "Integration", partnerId);
        getDoc(personDocRef)
            .then((partnerDoc) => {
            if (partnerDoc.exists()) {
                var partnerData = partnerDoc.data();
                const q = new URLSearchParams(window.location.search);
                integration[partnerId][partnerData.authCode] = q.get(partnerData.authCode);
                var tokenUrl = partnerData.baseUrl + partnerData.authToken;
                const formData = new URLSearchParams();
                Object.keys(partnerData.authTokenFields).forEach((f) => {
                    formData.append(f, partnerData.authTokenFields[f].replace("${" + f + "}", f === 'code' ? integration[partnerId][partnerData.authCode] : partnerData[f]));
                });
                fetch(tokenUrl, {
                    method: 'POST',
                    //headers: new Headers({"Authorization": `Basic ${partnerData.client_id}`}),
                    body: formData
                })
                    .then(response => { console.log(response); return response.json(); })
                    .then((respToken) => {
                    console.log(respToken);
                    integration[partnerId].accessToken = respToken;
                    return fetch(partnerData.baseUrl + partnerData.authCurrentUser, {
                        headers: {
                            "Accept": "application/vnd.plic.io.v2+json",
                            "Authorization": integration[partnerId].accessToken.token_type + ' ' + integration[partnerId].accessToken.access_token,
                        }
                    });
                })
                    .then(response => { console.log(response); return response.json(); })
                    .then((resp) => {
                    console.log(resp);
                    integration[partnerId].user = resp;
                    return updateDoc(personDoc.ref, { integration: integration });
                }).then(() => {
                    alert("UPDATED PERSON WITH INTEGRATION");
                    window.close();
                });
            }
        });
    }
    return {
        type: PERSON_LOADED,
        personDoc
    };
};
export const firebaseSignOut = () => {
    return {
        type: FIREBASE_SIGNOUT
    };
};
export const firebaseFirestore = (userDoc) => {
    return {
        type: FIREBASE_FIRESTORE,
        userDoc
    };
};
export const loadOrganizations = (companyRef) => {
    return {
        type: LOAD_ORGANIZATIONS,
        companyRef: companyRef
    };
};
export const loadJobs = (year) => {
    return {
        type: LOAD_JOBS,
        year: year
    };
};
export const loadJobTypes = () => {
    return {
        type: LOAD_JOBTYPES
    };
};
export const loadBackgroundSets = () => {
    return {
        type: LOAD_BACKGROUNDSETS
    };
};
export const organizationsLoaded = (organizations) => {
    return {
        type: ORGANIZATIONS_LOADED,
        organizations
    };
};
export const jobsLoaded = (jobs) => {
    return {
        type: JOBS_LOADED,
        jobs
    };
};
export const jobGet = (jobId) => {
    return {
        type: JOB_GET,
        jobId: jobId
    };
};
export const jobTypesLoaded = (jobTypes) => {
    return {
        type: JOBTYPES_LOADED,
        jobTypes
    };
};
export const backgroundSetsLoaded = (backgroundSets) => {
    return {
        type: BACKGROUNDSETS_LOADED,
        backgroundSets
    };
};
export const loadBackgrounds = (backgroundSetRef) => {
    return {
        type: LOAD_BACKGROUNDS,
        backgroundSetRef
    };
};
export const backgroundsLoaded = (backgrounds) => {
    return {
        type: BACKGROUNDS_LOADED,
        backgrounds
    };
};
const pendingJobRequests = new Map();
export const getJobById = async (jobIdOrRef) => {
    var _a, _b, _c, _d, _e;
    if (!jobIdOrRef)
        return undefined;
    const jobId = typeof jobIdOrRef === 'string' ? jobIdOrRef.split('/').pop() : jobIdOrRef.id;
    if (!jobId)
        return undefined;
    // 1. Look in the jobs array on the Redux app state first
    const state = (_a = store === null || store === void 0 ? void 0 : store.getState) === null || _a === void 0 ? void 0 : _a.call(store);
    const existingJob = ((_c = (_b = state === null || state === void 0 ? void 0 : state.app) === null || _b === void 0 ? void 0 : _b.jobs) === null || _c === void 0 ? void 0 : _c.find((j) => j && j.id === jobId)) ||
        ((_e = (_d = window.bws_appState) === null || _d === void 0 ? void 0 : _d.jobs) === null || _e === void 0 ? void 0 : _e.find((j) => j && j.id === jobId));
    if (existingJob) {
        return existingJob;
    }
    // 2. Check if a request for this job is already in flight
    if (pendingJobRequests.has(jobId)) {
        return pendingJobRequests.get(jobId);
    }
    const fetchPromise = (async () => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        try {
            let jobDocSnap = undefined;
            if (typeof jobIdOrRef !== 'string') {
                jobDocSnap = await getDoc(jobIdOrRef);
            }
            else if (jobIdOrRef.includes('/')) {
                const firestore = window.firestore || ((_a = state === null || state === void 0 ? void 0 : state.app) === null || _a === void 0 ? void 0 : _a.firestore);
                if (firestore) {
                    jobDocSnap = await getDoc(doc(firestore, jobIdOrRef));
                }
            }
            else {
                const companyRef = ((_c = (_b = state === null || state === void 0 ? void 0 : state.app) === null || _b === void 0 ? void 0 : _b.companyDoc) === null || _c === void 0 ? void 0 : _c.ref) ||
                    ((_d = window.company) === null || _d === void 0 ? void 0 : _d.ref) ||
                    ((_f = (_e = window.bws_appState) === null || _e === void 0 ? void 0 : _e.companyDoc) === null || _f === void 0 ? void 0 : _f.ref) ||
                    ((_g = window.person) === null || _g === void 0 ? void 0 : _g.get("company"));
                if (companyRef) {
                    const jobDocRef = doc(collection(companyRef, "Jobs"), jobId);
                    jobDocSnap = await getDoc(jobDocRef);
                }
                else {
                    const firestore = window.firestore || ((_h = state === null || state === void 0 ? void 0 : state.app) === null || _h === void 0 ? void 0 : _h.firestore);
                    if (firestore) {
                        const jobDocRef = doc(firestore, "Jobs", jobId);
                        jobDocSnap = await getDoc(jobDocRef);
                    }
                }
            }
            if (jobDocSnap && jobDocSnap.exists()) {
                return jobDocSnap;
            }
        }
        catch (error) {
            console.error(`[BWS] Failed to get job ${jobId} from Firestore:`, error);
        }
        finally {
            pendingJobRequests.delete(jobId);
        }
        return undefined;
    })();
    pendingJobRequests.set(jobId, fetchPromise);
    return fetchPromise;
};
export const getJob = getJobById;
// Assign globally to window
if (typeof window !== 'undefined') {
    window.getJobById = getJobById;
    window.getJob = getJobById;
}
